import * as echarts from 'echarts'

export default {
	props: { dataAtual: 0.0 },
	data() {
		return {
			optionsMedidorAgendamento: {
				series: [
					{
						type: 'gauge',
						startAngle: 180,
						endAngle: 0,
						center: ['50%', '75%'],
						radius: '90%',
						min: 0,
						max: 1,
						splitNumber: 6,
						axisLine: {
							lineStyle: {
								width: 6,
								color: [
									[0.167, '#fc5655'],
									[0.333, '#fd8888'],
									[0.5, '#fee115'],
									[0.667, '#d1d80f'],
									[0.833, '#83bd32'],
									[1, '#30ad43'],
								],
							},
						},
						pointer: {
							icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
							length: '12%',
							width: 20,
							offsetCenter: [0, '-60%'],
							itemStyle: {
								color: 'auto',
							},
						},
						axisTick: {
							length: 12,
							lineStyle: {
								color: 'auto',
								width: 2,
							},
						},
						splitLine: {
							length: 20,
							lineStyle: {
								color: 'auto',
								width: 5,
							},
						},
						axisLabel: {
							color: '#464646',
							fontSize: 16,
							distance: -60,
							align: 'center',
							rotate: 'tangential',
							formatter: function (value) {
								const v = Number(value.toFixed(4))
								const labels = {
									0.1667: 'MUITO BAIXO',
									0.3333: 'ABAIXO\nESPERADO',
									0.5: 'PARCIAL\nBAIXO',
									0.6667: 'PARCIAL\nBOM',
									0.8333: 'BOM',
									1: 'EXCELENTE',
								}
								return labels[v] || ''
							},
						},
						title: {
							offsetCenter: [0, '-10%'],
							fontSize: 20,
						},
						detail: {
							fontSize: 30,
							offsetCenter: [0, '-35%'],
							valueAnimation: true,
							formatter: function (value) {
								return Math.round(value * 100) + '%'
							},
							color: 'inherit',
						},
						data: [
							{
								value: 0.2,
								name: 'txt',
							},
						],
					},
				],
			},
			chartMedidor: null,
		}
	},
	watch: {
		dataAtual(newValue) {
			this.updateGauge(newValue)
		},
	},
	methods: {
		initMedidorChart() {
			const chartDom = document.getElementById(
				'chart_medidor_politica_agendamento'
			)
			this.chartMedidor = echarts.init(chartDom)

			this.updateGauge(this.dataAtual)

			/* chartMedidor.setOption(this.optionsMedidorAgendamento) */
		},
		updateGauge(value) {
			const labels = [
				{ lim: 0.1667, txt: 'MUITO BAIXO' },
				{ lim: 0.3333, txt: 'ABAIXO DO ESPERADO' },
				{ lim: 0.5, txt: 'PARCIAL BAIXO' },
				{ lim: 0.6667, txt: 'PARCIAL BOM' },
				{ lim: 0.8333, txt: 'BOM' },
				{ lim: 1, txt: 'EXCELENTE' },
			]
			const labelObj = labels.find((l) => value <= l.lim) || {
				txt: '',
				cor: '#464646',
			}
			this.optionsMedidorAgendamento.series[0].data[0].value = value
			this.optionsMedidorAgendamento.series[0].data[0].name = labelObj.txt
			this.optionsMedidorAgendamento.series[0].detail.color = labelObj.cor
			this.optionsMedidorAgendamento.series[0].title.color = labelObj.cor
			this.chartMedidor.setOption(this.optionsMedidorAgendamento, true)
		},
	},
	mounted() {
		this.initMedidorChart()
	},
	template: `
        <div id="chart_medidor_politica_agendamento" style="width: 100%; height: 400px;"></div>
    `,
}
